import JobsCompletedCard from "./JobsCompletedCard";

export default JobsCompletedCard;
